import type { Outfit } from '@/types/closet'

// Rotation videos are the heavy part of switching looks, and a browser only
// buffers a <video> that exists. A detached element with preload="auto"
// starts the download on intent (hover, focus, touch) so the video is warm by
// the time the look is selected. Capped so idle hovering can't pull the whole
// collection.
const MAX_WARM = 4
const warmed = new Map<string, HTMLVideoElement>()

export function warmLook(outfit: Outfit | undefined, dark: boolean) {
  const media = outfit?.lookbookMedia
  const src = dark ? media?.rotationUrlDark : media?.rotationUrl
  if (!src || warmed.has(src) || typeof document === 'undefined') return

  const video = document.createElement('video')
  video.muted = true
  video.preload = 'auto'
  video.src = src
  warmed.set(src, video)

  if (warmed.size > MAX_WARM) {
    const [oldest, stale] = warmed.entries().next().value!
    stale.removeAttribute('src')
    stale.load()
    warmed.delete(oldest)
  }
}
